import { render, staticRenderFns } from "./sourceInpute.vue?vue&type=template&id=5c20bf88&scoped=true"
import script from "./sourceInpute.vue?vue&type=script&lang=js"
export * from "./sourceInpute.vue?vue&type=script&lang=js"
import style0 from "./sourceInpute.vue?vue&type=style&index=0&id=5c20bf88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c20bf88",
  null
  
)

export default component.exports